import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import {
  OperatorActivityLog,
  SurveyActivityLog,
  SurveyActivityLogEntry,
} from '@ps/survey-utils';

import { SurveyActivityLogApi } from '../../api/survey-activity-log/survey-activity-log.api';

@Injectable({ providedIn: 'root' })
export class SurveyActivityLogService {
  private readonly _api = inject(SurveyActivityLogApi);

  public logActivity(log: SurveyActivityLog): Observable<void> {
    return this._api.post(log);
  }

  public logOperatorActivity(log: OperatorActivityLog): Observable<void> {
    return this._api.postOperator(log);
  }

  public getBySurveyId(surveyId: number): Observable<SurveyActivityLogEntry[]> {
    return this._api.getBySurveyId(surveyId);
  }
}
